// ----------------------------------------------------------------------

export default function Link() {
  return {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
  };
}
